<template>
  <div class="inp_combo center phone">
    <template v-if="type === 'national' || type === 'service'">
      <template v-if="type === 'national' && !isCustom">
        <Selector v-model="part1" :options="codesNationalNumber" labelKey="code" valueKey="code" @change="onChangeNationalSelector" />
      </template>
      <template v-if="type === 'national' && isCustom">
        <Selector
          value="직접입력"
          :options="codesNationalNumber"
          labelKey="code"
          valueKey="code"
          @change="onChangeNationalSelector"
        />
        <InputText placeholder="직접입력" type="tel" onlyNumber maxLength="3" v-model="part1" />
      </template>

      <template v-if="type === 'service' && !isCustom">
        <Selector v-model="part1" :options="codesAddSvcNumber" labelKey="code" valueKey="code" @change="onChangeNationalSelector"/>
      </template>
      <template v-if="type === 'service' && isCustom">
        <Selector
          value="직접입력"
          :options="codesAddSvcNumber"
          labelKey="code"
          valueKey="code"
          @change="onChangeNationalSelector"
        />
        <InputText placeholder="직접입력" type="tel" onlyNumber maxLength="4" v-model="part1" />
      </template>
      <span class="anchor">-</span>
    </template>

    <InputText type="tel" ref="telNoRef" :placeholder="placeholder" v-model="part2" :maxlength="maxLength" onlyNumber />
  </div>
</template>

<script>
import { computed, defineComponent, ref, toRefs, unref } from '@vue/composition-api';
import { useCommonCodes } from '@/utils/hooks';
import InputText from './InputText';
import Selector from './Selector';

export default defineComponent({
  components: {
    InputText,
    Selector,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    /**
     * 전화번호 유형
     * mobile: 휴대전화, national: 일반 전화번호, service: 부가서비스 전화번호
     */
    type: {
      type: String,
      default: 'mobile',
    },
  },

  setup(props, { emit }) {
    const { value, type } = toRefs(props);

    /** 직접입력 활성여부 */
    const isCustom = ref(false);

    /** 일반전화번호 국번 코드 목록 */
    const codesNationalNumber = useCommonCodes('NATIONAL_NUMBER');
    /** 부가서비스 전화번호 국번 코드 목록 */
    const codesAddSvcNumber = useCommonCodes('ADD_SVC_NUMBER');

    const maxLength = computed(() => {
      if (unref(type) === 'mobile') return 11;
      if (unref(type) === 'national') return 8;
      if (unref(type) === 'service') return 4;
    });

    const placeholder = computed(() => {
      return `(-없이) 최대 ${unref(maxLength)}자리 입력`
    });

    const part1 = computed({
      get: () => {
        const [p1] = unref(value).split('-');
        if (unref(type) === 'national') return p1;
        if (unref(type) === 'service') return p1;
        return '';
      },
      set: (v) => {
        const [p1, ...rest] = unref(value).split('-');
        const newValue = [v, ...rest].join('-');
        if (unref(value) === newValue) return;
        emit('change', newValue);
      },
    });

    const part2 = computed({
      get: () => {
        const [p1, ...rest] = unref(value).split('-');
        if (unref(type) === 'national') return rest.join('');
        if (unref(type) === 'service') return rest.join('');
        return [p1, ...rest].join('');
      },
      set: (v) => {
        const [p1] = unref(value).split('-');
        const newValue = (() => {
          if (unref(type) === 'mobile') {
            return [v.substr(0, 3), v.substr(3, v.length < 11 ? 3 : 4), v.substr(v.length < 11 ? 6 : 7)].filter(Boolean).join('-');
          }
          if (unref(type) === 'national') {
            const p2Size = v.length < 8 ? 3 : 4;
            const p2 = v.substr(0, p2Size);
            const p3 = v.substr(p2Size);
            return [p1, p2, p3].join('-');
          }
          return [p1, v].join('-');
        })();
        if (unref(value) === newValue) return;
        emit('change', newValue);
      },
    });

    return {
      codesNationalNumber,
      codesAddSvcNumber,
      isCustom,

      onChangeNationalSelector(e) {
        if ((isCustom.value = e.target.value === '직접입력')) {
          part1.value = '';
        }
        else{
          part1.value = e.target.value;
        }
      },

      maxLength,
      placeholder,

      part1,
      part2,
    };
  },
});
</script>
